/**
 * @param {ChildNode} children - title text
 * @param {StyleSheet} [style] - additional style to form title
 */
import React from 'react';
import { Text } from 'react-native';
import { themeForm } from '../../styles';

type props = {
  children: React.ReactNode;
  style?: any;
};

export const FormTitle = ({ children, style = {} }: props) => {
  return <Text style={[themeForm.formTitle, style]}>{children}</Text>;
};
